import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { getFilesBlockId, getFoldersBlockId } from '../utils/rendererUtils';

export const useFilesAndFoldersId = (folderUuidRef) => {
  const { fileUuid, folderUuid } = useParams();
  const [filesId, setFilesId] = useState(getFilesBlockId(folderUuid));
  const [foldersId, setFoldersId] = useState(getFoldersBlockId(folderUuid));

  useEffect(() => {
    const isRootPath = !folderUuid && !fileUuid;

    if (folderUuid || isRootPath) {
      folderUuidRef.current = folderUuid;
      setFilesId(getFilesBlockId(folderUuid));
      setFoldersId(getFoldersBlockId(folderUuid));
    }
  }, [folderUuid, fileUuid]);

  return { filesId, foldersId };
};
